import { createApi } from '@reduxjs/toolkit/query/react';
import { carBaseQuery } from '@app/api/carBaseQuery';
import type {
  MeetingGuidanceResponse,
  MeetingGuidanceSignalCatalogResponse,
  MeetingGuidanceTemplateListResponse,
  MeetingIntake,
  MeetingIntakeSaveRequest,
} from '../types';
import { API_BASE_PATH } from '../constants';

interface MeetingGuidanceRequest {
  planResultRootId: string;
  planResultTypeId: string;
}

export const meetingGuidanceApi = createApi({
  reducerPath: 'meetingGuidanceApi',
  baseQuery: carBaseQuery,
  tagTypes: ['MeetingGuidance'],
  endpoints: (builder) => ({
    getMeetingGuidance: builder.query<
      MeetingGuidanceResponse,
      MeetingGuidanceRequest
    >({
      query: ({ planResultRootId, planResultTypeId }) => ({
        url: `${API_BASE_PATH}/${planResultRootId}/${planResultTypeId}/meeting-guidance/`,
        method: 'GET',
      }),
      providesTags: ['MeetingGuidance'],
    }),
    getMeetingGuidanceTemplates: builder.query<
      MeetingGuidanceTemplateListResponse,
      MeetingGuidanceRequest
    >({
      query: ({ planResultRootId, planResultTypeId }) => ({
        url: `${API_BASE_PATH}/${planResultRootId}/${planResultTypeId}/meeting-guidance/templates/`,
        method: 'GET',
      }),
    }),
    getMeetingGuidanceSignalCatalog: builder.query<
      MeetingGuidanceSignalCatalogResponse,
      MeetingGuidanceRequest
    >({
      query: ({ planResultRootId, planResultTypeId }) => ({
        url: `${API_BASE_PATH}/${planResultRootId}/${planResultTypeId}/meeting-guidance/signals/`,
        method: 'GET',
      }),
    }),
    saveMeetingGuidanceIntake: builder.mutation<
      MeetingIntake,
      MeetingGuidanceRequest & { intake: MeetingIntakeSaveRequest }
    >({
      query: ({ planResultRootId, planResultTypeId, intake }) => ({
        url: `${API_BASE_PATH}/${planResultRootId}/${planResultTypeId}/meeting-guidance/intake/`,
        method: 'PUT',
        body: intake,
      }),
      invalidatesTags: ['MeetingGuidance'],
    }),
  }),
});

export const {
  useGetMeetingGuidanceQuery,
  useGetMeetingGuidanceSignalCatalogQuery,
  useGetMeetingGuidanceTemplatesQuery,
  useSaveMeetingGuidanceIntakeMutation,
} = meetingGuidanceApi;
